import React, { Component } from 'react';
import * as Progress from 'react-native-progress';
import { StyleSheet, View, TouchableOpacity, Platform } from 'react-native';
import { Input, Button, Text, Icon, Colors, Line, Routes } from '../components';
import { StringUtils, DateUtils } from '../utils';
import { useNavigate } from 'react-router-dom';

class HomeUpcomingAppointments_Base extends Component {

  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
    }
  }

  render_list_header = () => {
    let consultations   = this.props.consultations || [];
    let button_text     = this.state.expanded ? 'Minimize' : 'See All';
    let display_see_all = consultations && consultations.length > 3 ? true : false;

    return <View style={styles.list_header}>
      <Text style={{ fontWeight: '500', fontSize: 18 }}>Upcoming Appointments</Text>

      { display_see_all ? <TouchableOpacity style={[styles.see_all_button, { backgroundColor: Colors.PRIMARY } ]}
                        onPress={ () => {
                          this.setState({ expanded: !this.state.expanded })
                        }}>
        <Icon name='times-circle' color='white' solid={true} size={13} style={{ marginRight: 5 }} hide={!this.state.expanded} />
        <Text style={{ fontWeight: '500', color: 'white', fontSize: 12 }}>{ button_text }</Text>
      </TouchableOpacity> : null }

    </View>
  }

  render_list = () => {
    let consultations = this.props.consultations || [];

    let appointments = consultations.map((consultation, index) => {

      if (!this.state.expanded && index > 2) {
        return null;
      }

      let consultation_id = consultation._id;
      let display_dot = false;
      let pet_name    = consultation && consultation.patient ? StringUtils.displayName(consultation.patient) : '';
      let date_str    = 'Video Appointment'; //DateUtils.getLongMonth(consultation.created_at) + ' ' + DateUtils.getDateNumber(consultation.created_at) + ', ' + DateUtils.getYear(consultation.created_at);

      return <View key={consultation_id}>
        <TouchableOpacity style={{ paddingTop: 15, paddingBottom: 15, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}
                          onPress={ () => {
                            if(Platform.OS === 'web') {
                              console.log('navigateing here', consultation_id)
                              let route = `${Routes.CONSULTATION_VIDEO_APPOINTMENT}?consultation_id=${consultation_id}`
                              this.props.navigate(route);
                            } else {
                              this.props.navigate(Routes.CONSULTATION_VIDEO_APPOINTMENT, { consultation_id })
                            }
                          }}>
          <View>
            <Text style={{ fontSize: 14, fontWeight: '500', color: '#040415' }}>{ pet_name }</Text>
            <Text style={{ fontSize: 14, color: '#575762', marginTop: 3 }}>{ date_str }</Text>
          </View>
          <View>
            <Icon name={ display_dot ? 'circle' : 'chevron-right' } solid={true} size={ display_dot ? 12 : 15} color={ display_dot ? Colors.RED : '#cccccc'} />
          </View>
        </TouchableOpacity>
        <Line />
      </View>
    }).filter((row) => { return row });

    return <View>
      { appointments }
    </View>
  }

  render() {

    if (this.props.hide) {
      return null;
    }

    return (
      <View style={styles.main_container}>
        { this.render_list_header() }
        { this.render_list ()       }
      </View>
    );
  }
}

function HomeUpcomingAppointments(props) {
  if(Platform.OS === 'web') {
    const navigate = useNavigate();
    return  <HomeUpcomingAppointments_Base {...props} navigate={navigate} />
  } else {
    return  <HomeUpcomingAppointments_Base {...props} navigate={props.navigation.push}  />
  }
}

const styles = StyleSheet.create({
  list_header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 10
  },
  main_container: {
    padding: 20,
    paddingBottom: 0,
  },
  see_all_button: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 6,
    borderRadius: 30,
    paddingRight: 15,
    paddingLeft: 15
  }
});

export default HomeUpcomingAppointments
